import {Component} from 'react';
import axios from "axios"
import Nav from "../Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import * as XLSX from "xlsx";

let source = axios.CancelToken.source();

class Dashboard4 extends Component {
    constructor() {
        super();
        this.state = {
            objs: [],
            objsl: false,
        }
    }
    tablevstatus=()=> {
        let retdata = null;
        if (this.state.objsl) {
            retdata = this.state.objs.vstatus.map(value => {
                return (<tr>
                    <th>{value.loc}</th>
                    <td>{value.count}</td>
                </tr>)
            })
        }
        return <>{retdata}</>
    }
    tablediredawa_sum=()=> {
        let retdata = null;
        if (this.state.objsl) {
            retdata = this.state.objs.diredawa_sum.map(value => {
                return (<tr>
                    <th>{value.eta}</th>
                    <td>{value.count}</td>
                </tr>)
            })
        }
        return <>{retdata}</>
    }
    tabledawero_sum=()=> {
        let retdata = null;
        if (this.state.objsl) {
            retdata = this.state.objs.dawero_sum.map(value => {
                return (<tr>
                    <th>{value.eta}</th>
                    <td>{value.count}</td>
                </tr>)
            })
        }
        return <>{retdata}</>
    }
    tablekoka_sum=()=> {
        let retdata = null;
        if (this.state.objsl) {
            retdata = this.state.objs.koka_sum.map(value => {
                return (<tr>
                    <th>{value.eta}</th>
                    <td>{value.count}</td>
                </tr>)
            })
        }
        return <>{retdata}</>
    }
    tablediredawa_det=()=> {
        let retdata = null;
        if (this.state.objsl) {
            let count=0;
            retdata = this.state.objs.diredawa_det.map(value => {
                count=count+1;
                return (<tr>
                    <th>{count}</th>
                    <th>{value.plate_no}</th>
                    <th>{value.eta}</th>
                    <td>{value.km}</td>
                    <td>{value.isarrived}</td>
                    <td>{value.loc}</td>
                    <td>{value.avltime}</td>
                    <td>{value.from}</td>
                    <td>{value.status}</td>
                </tr>)
            })
        }
        return <>{retdata}</>
    }
    tabledawero_det=()=> {
        let retdata = null;
        if (this.state.objsl) {
            let count=0;
            retdata = this.state.objs.dawero_det.map(value => {
                count=count+1;
                return (<tr>
                    <th>{count}</th>
                    <th>{value.plate_no}</th>
                    <th>{value.eta}</th>
                    <td>{value.km}</td>
                    <td>{value.isarrived}</td>
                    <td>{value.loc}</td>
                    <td>{value.avltime}</td>
                    <td>{value.from}</td>
                    <td>{value.status}</td>
                </tr>)
            })
        }
        return <>{retdata}</>
    }
    tablekoka_det=()=> {
        let retdata = null;
        if (this.state.objsl) {
            let count=0;
            retdata = this.state.objs.koka_det.map(value => {
                count=count+1;
                return (<tr>
                    <th>{count}</th>
                    <th>{value.plate_no}</th>
                    <th>{value.eta}</th>
                    <td>{value.km}</td>
                    <td>{value.isarrived}</td>
                    <td>{value.loc}</td>
                    <td>{value.avltime}</td>
                    <td>{value.from}</td>
                    <td>{value.status}</td>
                </tr>)
            })
        }
        return <>{retdata}</>
    }
    componentDidMount() {
        this.fetcheddata()
    }
    fetcheddata = () => {
        let baseurl = myconfig.dashboard_4;
        let redirecttologin = myconfig.redirecttologin;
        this.setState({
            objs: [],
            objsl: false,
        })
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    objs: res.data,
                    objsl: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    btnexport_Dire_Dawa = (event) => {
        event.preventDefault();
        let wb=XLSX.utils.book_new();
        wb.SheetNames.push("Dire_Dawa");
        let wb2= XLSX.utils.table_to_sheet(document.getElementById('Dire_Dawa'));
        wb.Sheets["Dire_Dawa"]=wb2;
        XLSX.writeFile(wb,"Dire_Dawa.xlsx");
    }
    btnexport_Dawro = (event) => {
        event.preventDefault();
        let wb=XLSX.utils.book_new();
        wb.SheetNames.push("Dawro");
        let wb2= XLSX.utils.table_to_sheet(document.getElementById('Dawro'));
        wb.Sheets["Dawro"]=wb2;
        XLSX.writeFile(wb,"Dawro.xlsx");
    }
    btnexport_Koka = (event) => {
        event.preventDefault();
        let wb=XLSX.utils.book_new();
        wb.SheetNames.push("Koka");
        let wb2= XLSX.utils.table_to_sheet(document.getElementById('Koka'));
        wb.Sheets["Koka"]=wb2;
        XLSX.writeFile(wb,"Koka.xlsx");
    }
    render() {
        return (
            <>
                <Nav type="dashboard4"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Dashboard-4</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="#">Home</a></li>
                                        <li className="breadcrumb-item active">Dashboard-4</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-md-4">
                                    <div className="card card-primary">
                                        <div className="card-header">
                                            <h3 className="card-title">Vehicle Status</h3>
                                        </div>
                                        <div className="card-body table-responsive p-0" style={{height: '300px'}}>
                                            <table className="table table-head-fixed text-nowrap">
                                                <thead>
                                                <tr>
                                                    <th>Type</th>
                                                    <th>Count</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.tablevstatus()}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="card card-cyan">
                                        <div className="card-header">
                                            <h3 className="card-title">Dire-Dawa</h3>
                                        </div>
                                        <div className="card-body table-responsive p-0" style={{height: '300px'}}>
                                            <table className="table table-head-fixed text-nowrap">
                                                <thead>
                                                <tr>
                                                    <th>ETA</th>
                                                    <th>Count</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.tablediredawa_sum()}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="card card-fuchsia">
                                        <div className="card-header">
                                            <h3 className="card-title">Dawro</h3>
                                        </div>
                                        <div className="card-body table-responsive p-0" style={{height: '300px'}}>
                                            <table className="table table-head-fixed text-nowrap">
                                                <thead>
                                                <tr>
                                                    <th>ETA</th>
                                                    <th>Count</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.tabledawero_sum()}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="card card-cyan">
                                        <div className="card-header">
                                            <h3 className="card-title">Koka</h3>
                                        </div>
                                        <div className="card-body table-responsive p-0" style={{height: '300px'}}>
                                            <table className="table table-head-fixed text-nowrap">
                                                <thead>
                                                <tr>
                                                    <th>ETA</th>
                                                    <th>Count</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.tablekoka_sum()}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="card card-primary">
                                        <div className="card-header">
                                            <h3 className="card-title">Dire-Dawa Detailed</h3>
                                        </div>

                                        <div className="card-body table-responsive p-0" style={{height: '300px'}}>
                                            <div className="p-1 text-left"><a href="#" onClick={this.btnexport_Dire_Dawa}>.xlsx</a></div>
                                            <table id="Dire_Dawa" className="table table-head-fixed text-nowrap">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Truck</th>
                                                    <th>ETA</th>
                                                    <th>Left Millage</th>
                                                    <th>Is Arrived</th>
                                                    <th>Location</th>
                                                    <th>Update Time</th>
                                                    <th>From</th>
                                                    <th>Status</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.tablediredawa_det()}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="card card-cyan">
                                        <div className="card-header">
                                            <h3 className="card-title">Dawro Detailed</h3>
                                        </div>

                                        <div className="card-body table-responsive p-0" style={{height: '300px'}}>
                                            <div className="p-1 text-left"><a href="#" onClick={this.btnexport_Dawro}>.xlsx</a></div>
                                            <table id="Dawro" className="table table-head-fixed text-nowrap">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Truck</th>
                                                    <th>ETA</th>
                                                    <th>Left Millage</th>
                                                    <th>Is Arrived</th>
                                                    <th>Location</th>
                                                    <th>Update Time</th>
                                                    <th>From</th>
                                                    <th>Status</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.tabledawero_det()}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="card card-fuchsia">
                                        <div className="card-header">
                                            <h3 className="card-title">Koka Detailed</h3>
                                        </div>

                                        <div className="card-body table-responsive p-0" style={{height: '300px'}}>
                                            <div className="p-1 text-left"><a href="#" onClick={this.btnexport_Koka}>.xlsx</a></div>
                                            <table id="Koka" className="table table-head-fixed text-nowrap">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Truck</th>
                                                    <th>ETA</th>
                                                    <th>Left Millage</th>
                                                    <th>Is Arrived</th>
                                                    <th>Location</th>
                                                    <th>Update Time</th>
                                                    <th>From</th>
                                                    <th>Status</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.tablekoka_det()}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>
                </div>
            </>
        )
    }
}

export default Dashboard4;
